<!--列表查看视图-->
<template>
  <div>
    <template v-if="lob==='AI'">
      <template v-if="masterFlag">
        <ai-master-basic-tab-UICustom v-if="$store.state.uiCustom.enable" ref="tabAIBasicMaster" :context="seContext" :action="action" view-source="financeDetail" />
        <ai-master-basic-tab v-else ref="tabAIBasicMaster" :context="seContext" :action="action" view-source="financeDetail" />
      </template>
      <template v-if="!masterFlag">
        <ai-basic-tab-UICustom v-if="$store.state.uiCustom.enable" ref="tabAIBasic" :context="seContext" :action="action" />
        <ai-basic-tab v-else ref="tabAIBasic" :context="seContext" :action="action" />
      </template>
    </template>
    <template v-if="lob==='AE'">
      <template v-if="masterFlag">
        <ae-tab-master-UICustom v-if="$store.state.uiCustom.enable" ref="tabAEBasicMaster" :context="seContext" :action="action" view-source="financeDetail" />
        <ae-master-basic-tab v-else ref="tabAEBasicMaster" :context="seContext" :action="action" view-source="financeDetail" />
      </template>
      <template v-if="!masterFlag">
        <ae-tab-general-UICustom v-if="$store.state.uiCustom.enable" ref="tabAEBasic" :context="seContext" :action="action" />
        <ae-basic-tab v-else ref="tabAEBasic" :context="seContext" :action="action" />
      </template>
    </template>

    <template v-if="lob==='SI'">
      <template v-if="masterFlag">
        <si-master-basic-tab-UICustom v-if="$store.state.uiCustom.enable" ref="tabSiBasicMaster" :context="seContext" :action="action" view-source="financeDetail" />
        <si-master-basic-tab v-else ref="tabSiBasicMaster" :context="seContext" :action="action" view-source="financeDetail" />
      </template>
      <template v-if="!masterFlag">
        <si-basic-tab-UICustom v-if="$store.state.uiCustom.enable" ref="tabSiBasic" :context="seContext" :action="action" />
        <si-basic-tab v-else ref="tabSiBasic" :context="seContext" :action="action" />
      </template>
    </template>
    <template v-if="lob==='SE'">
      <template v-if="masterFlag">
        <tab-booking-master-UICustom v-if="$store.state.uiCustom.enable" ref="tabBookingMaster" :context="seContext" :action="action" class="se-basic-tab" view-source="financeDetail" />
        <tab-booking-master v-else ref="tabBookingMaster" :context="seContext" :action="action" class="se-basic-tab" view-source="financeDetail" />
      </template>
      <template v-if="!masterFlag">
        <tab-booking-FCLUICustom v-if="$store.state.uiCustom.enable" ref="tabBookingFCL" :slave-customs-declaration-enable="slaveCustomsDeclarationEnable" :context="seContext" :action="action" class="se-basic-tab" />
        <tab-booking-fcl v-else ref="tabBookingFCL" :slave-customs-declaration-enable="slaveCustomsDeclarationEnable" :context="seContext" :action="action" class="se-basic-tab" />
      </template>
    </template>
    <template v-if="lob==='RE'||lob==='RI'">
      <template v-if="masterFlag">
        <re-tab-booking-master-UICustom v-if="$store.state.uiCustom.enable" ref="reTabBookingMaster" :context="seContext" :action="action" view-source="financeDetail" />
        <re-tab-booking-master v-else ref="reTabBookingMaster" :context="seContext" :action="action" view-source="financeDetail" />
      </template>
      <template v-if="!masterFlag">
        <re-tab-booking-fcl-UICustom v-if="$store.state.uiCustom.enable" ref="reTabBookingFcl" :context="seContext" :action="action" />
        <re-tab-booking-fcl v-else ref="reTabBookingFcl" :context="seContext" :action="action" />
      </template>
    </template>
    <template v-if="lob==='IE'">
      <!-- 集卡拖车基础-->
      <template v-if="job.containerLoadType === 'TT'">
        <tab-gathering-trailer-base-UICustom v-if="$store.state.uiCustom.enable" ref="tabGatheringTrailerBase" :context="seContext" :action="action" />
        <tab-gathering-trailer-base v-else ref="tabGatheringTrailerBase" :context="seContext" :action="action" />
      </template>
      <!-- 整车/零担基础-->
      <template v-if="job.containerLoadType === 'CL'">
        <tab-less-than-carload-base-UICustom v-if="$store.state.uiCustom.enable" ref="tabLessThanCarloadBase" :context="seContext" :action="action" />
        <tab-less-than-carload-base v-else ref="tabLessThanCarloadBase" :context="seContext" :action="action" />
      </template>
      <!-- 国际卡航基础-->
      <template v-if="masterFlag && job.containerLoadType === 'IC'">
        <tab-international-card-base-master-UICustom v-if="$store.state.uiCustom.enable" ref="tabInternationalCard" :context="seContext" :action="action" />
        <tab-international-card-base-master v-else ref="tabInternationalCard" :context="seContext" :action="action" />
      </template>
      <template v-if="!masterFlag && job.containerLoadType === 'IC'">
        <tab-international-card-base-UICustom v-if="$store.state.uiCustom.enable" ref="tabInternationalCard" :context="seContext" :action="action" />
        <tab-international-card-base v-else ref="tabInternationalCard" :context="seContext" :action="action" />
      </template>
    </template>
  </div>
</template>

<script>

import { getLoading } from '@/utils/utilBaseElement'

import tabLessThanCarloadBase from '@/views/cargo/v0/Integrated/components/booking/tabs/tabLessThanCarloadBase'
import tabGatheringTrailerBase from '@/views/cargo/v0/Integrated/components/booking/tabs/tabGatheringTrailerBase'
import tabGatheringTrailerBaseUICustom from '@/views/cargo/v0/Integrated/components/booking/tabs/tabGatheringTrailerBaseUICustom'

import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import aiBasicTab from '@/views/cargo/v0/AirImport/components/booking/tabs/tabBookingFCL.vue'
import aiBasicTabUICustom from '@/views/cargo/v0/AirImport/components/booking/tabs/tabBookingFCLUICustom.vue'
import aiMasterBasicTab from '@/views/cargo/v0/AirImport/components/booking/tabs/tabBookingMaster.vue'
import aiMasterBasicTabUICustom from '@/views/cargo/v0/AirImport/components/booking/tabs/tabBookingMasterUICustom.vue'

import aeBasicTab from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/tabGeneral'
import aeTabGeneralUICustom from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/tabGeneralUICustom'
import aeMasterBasicTab from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/tabMaster'
import aeTabMasterUICustom from '@/views/cargo/v0/AirExport/components/AeBooking/tabs/tabMasterUICustom'

import siBasicTab from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/basicTab'
import siMasterBasicTab from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/masterBasicTab'
import siBasicTabUICustom from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/basicTabUICustom'
import siMasterBasicTabUICustom from '@/views/cargo/v0/SeaImport/components/SiBooking/tabs/masterBasicTabUICustom'
import reTabBookingFcl from '@/views/cargo/v0/RailwayExport/components/booking/tabs/tabBookingFCL'
import reTabBookingFclUICustom from '@/views/cargo/v0/RailwayExport/components/booking/tabs/tabBookingFCLUICustom'
import reTabBookingMaster from '@/views/cargo/v0/RailwayExport/components/booking/tabs/tabBookingMaster'
import reTabBookingMasterUICustom from '@/views/cargo/v0/RailwayExport/components/booking/tabs/tabBookingMasterUICustom'

import seBasicTab from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabBookingFCL'
import seMasterBasicTab from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabBookingMaster'
import tabBookingFcl from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabBookingFCL'
import tabBookingFCLUICustom from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabBookingFCLUICustom'
import tabBookingMaster from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabBookingMaster'
import tabBookingMasterUICustom from '@/views/cargo/v0/SeaExport/components/booking/tabs/tabBookingMasterUICustom'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import TabInternationalCardBaseMaster from '@/views/cargo/v0/Integrated/components/booking/tabs/tabInternationalCardBaseMaster'
import TabInternationalCardBase from '@/views/cargo/v0/Integrated/components/booking/tabs/tabInternationalCardBase'
import TabInternationalCardBaseMasterUICustom from '@/views/cargo/v0/Integrated/components/booking/tabs/tabInternationalCardBaseMasterUICustom'
import TabInternationalCardBaseUICustom from '@/views/cargo/v0/Integrated/components/booking/tabs/tabInternationalCardBaseUICustom'
import { SE } from '@/class/cargo/model/parameters/SystemConstants'
import { BB_CARGO_TYPE, BC_CARGO_TYPE, LCL_CARGO_TYPE } from '@/class/cargo/model/parameters/ContainerLoadType'
import tabLessThanCarloadBaseUICustom from '@/views/cargo/v0/Integrated/components/booking/tabs/tabLessThanCarloadBaseUICustom'

export default {
  name: 'FinanceDetail',
  components: {
    tabGatheringTrailerBaseUICustom, tabLessThanCarloadBaseUICustom,
    TabInternationalCardBaseMasterUICustom, TabInternationalCardBaseUICustom, TabInternationalCardBaseMaster, TabInternationalCardBase, tabBookingMaster, tabBookingMasterUICustom, tabBookingFcl, tabBookingFCLUICustom, cargoAdvanceSelect, seBasicTab, seMasterBasicTab,
    reTabBookingFcl, reTabBookingFclUICustom, reTabBookingMaster, reTabBookingMasterUICustom, siMasterBasicTab, siMasterBasicTabUICustom, aeMasterBasicTab, aeTabMasterUICustom, aiMasterBasicTab, aiMasterBasicTabUICustom,
    aiBasicTab, aiBasicTabUICustom, aeBasicTab, aeTabGeneralUICustom, siBasicTab, siBasicTabUICustom, tabLessThanCarloadBase, tabGatheringTrailerBase },
  props: {
    job: { type: Object, required: true },
    lob: { type: String, required: true, validator: (value) => { return ['AE', 'SE', 'SI', 'RE', 'RI', 'AI', 'IE', ''].includes(value) } }, // AE SE SI RWE, ''(空字符串）为解决初始化警告问题
    masterFlag: { type: Boolean, required: true },
    seContext: { type: Object, required: false }
  },
  data() {
    return {
      loading: false,
      selectTypeNames: TYPE_NAMES,
      activeTabName: 'aiBasicTab',
      action: 'look'
    }
  },
  computed: {
    config() {
      return this.seContext.config
    },
    seMultiSoMode() { // 海运出口开启拼箱小票多SO操作模式
      return this.config ? Number(this.config.get('SEMultiSoMode')) === 1 : false
    },
    slaveCustomsDeclarationEnable() { // 【小票】关单信息 是否可用
      return this.job.lob === SE.code && !this.job.masterFlag && this.seMultiSoMode && [LCL_CARGO_TYPE.code, BB_CARGO_TYPE.code, BC_CARGO_TYPE.code].indexOf(this.job.containerLoadType) >= 0
    }
  },
  methods: {
    onShow(row, isRefresh) {
      if (!isRefresh) {
        return
      }
      this.loading = getLoading()
      switch (this.lob) {
        case 'SE': {
          this.$nextTick(() => {
            const activeTabName = this.masterFlag ? 'tabBookingMaster' : 'tabBookingFCL'
            this.$refs[activeTabName].onShow(this.job, true)
          })
          break
        }
        case 'SI': {
          this.$nextTick(() => {
            const activeTabName = this.masterFlag ? 'tabSiBasicMaster' : 'tabSiBasic'
            this.$refs[activeTabName].onShow(this.job, true)
          })
          break
        }
        case 'AE': {
          this.$nextTick(() => {
            const activeTabName = this.masterFlag ? 'tabAEBasicMaster' : 'tabAEBasic'
            this.$refs[activeTabName].onShow(this.job, true)
          })
          break
        }
        case 'AI': {
          this.$nextTick(() => {
            const activeTabName = this.masterFlag ? 'tabAIBasicMaster' : 'tabAIBasic'
            this.$refs[activeTabName].onShow(this.job, true)
          })
          break
        }
        case 'RE':
        case 'RI': {
          const activeTabName = this.masterFlag ? 'reTabBookingMaster' : 'reTabBookingFcl'
          this.$refs[activeTabName].onShow(this.job, isRefresh)
          break
        }
        case 'IE': {
          let activeTabName = 'tabLessThanCarloadBase'
          if (this.job.containerLoadType === 'TT') {
            activeTabName = 'tabGatheringTrailerBase'
          } else if (this.job.containerLoadType === 'IC') {
            activeTabName = 'tabInternationalCard'
          }
          this.$refs[activeTabName].onShow(this.job, isRefresh)
          break
        }
      }
      this.loading.close()
    }
  }
}
</script>

<style lang="scss">

</style>
